import { Button, ButtonProps } from '@/components/ui/atoms/Button/Button';
import { type ElementType } from 'react';
import { FormattedMessage } from 'react-intl';

export type BackButtonProps = ButtonProps & {
  component?: ElementType;
  to?: string;
};

const BackButton = (props: BackButtonProps): JSX.Element => {
  return (
    <Button variant="secondary" {...props}>
      <FormattedMessage id="button.back" />
    </Button>
  );
};

export default BackButton;
